export default "__VITE_ASSET__BTWKUT9g__"